module.exports = __webpack_public_path__ + "assets/img/thumb-Logitech---BRIO-Video.1e1a92da.jpg";